import { Router, Switch, Route } from "react-router-dom";
import React from "react";

import { history } from "./shared/history/history";
import "bootstrap/dist/css/bootstrap.min.css";
import { library } from "@fortawesome/fontawesome-svg-core";

import FlappyBird from "./shared/components/flappyBird/FlappyBird";
import ContactMe from "./components/contact-me/ContactMe";
import Landing from "./components/landing-page/Landing";
import Projects from "./components/projects/Projects";
import AboutMe from "./components/about-me/AboutMe";
import Skills from "../src/components/skills/skills";
import {
  faBaby,
  faSchool,
  faCode,
  faBriefcase,
  faUniversity,
  faSitemap,
} from "@fortawesome/free-solid-svg-icons";
import "./App.scss";

function App() {
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/">
          <Landing />
        </Route>
        <Route exact path="/about-me">
          <AboutMe />
        </Route>
        <Route exact path="/contact-me">
          <ContactMe />
        </Route>
        <Route exact path="/projects">
          <Projects />
        </Route>
        <Route exact path="/projects/flappyBird">
          <FlappyBird />
        </Route>
        <Route exact path="/skills">
          <Skills />
        </Route>
      </Switch>
    </Router>
  );
}
library.add(faBaby, faSchool, faCode, faBriefcase, faSitemap, faUniversity);
export default App;
